/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Checkbox, Segment, Grid, Divider,
  Form, Popup, Icon, Button
} from "semantic-ui-react";
import Chart from "react-apexcharts";
//import ApexCharts from "apexcharts";
import Strings from "./utilities/StringSelector";
import Constants from "./utilities/Constants";
import Utils from "./utilities/Utils";

const UtilsInstance = new Utils();

const chartLocale = {
  name: "application-language",
  options: {
    months: Strings.CHART_MONTHS,
    shortMonths: Strings.CHART_SHORT_MONTHS,
    days: Strings.CHART_DAYS,
    shortDays: Strings.CHART_SHORT_DAYS,
    toolbar: {
      exportToSVG: Strings.CHART_DOWNLOAD_SVG,
      exportToPNG: Strings.CHART_DOWNLOAD_PNG,
      exportToCSV: Strings.CHART_DOWNLOAD_CSV,
      menu: Strings.CHART_DOWNLOAD,
      selection: Strings.CHART_SELECT,
      selectionZoom: Strings.CHART_SELECT_ZOOM,
      zoomIn: Strings.CHART_ZOOM_IN,
      zoomOut: Strings.CHART_ZOOM_OUT,
      pan: Strings.CHART_PAN,
      reset: Strings.CHART_RESET_ZOOM
    }
  }
};

export class PingGraph extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nowMillis: Date.now(),
      isDimmerActive: false,
      devices: [],
      checkboxList: {},
      series: [],
      options: {
        title: {
          text: Strings.PING_GRAPH,
          align: "center",
        },
        tooltip: {
          enabled: true,
          intersect: false,
          shared: false,
          onDatasetHover: {
            highlightDataSeries: true
          },
          x: {
            show: true,
            formatter: function (val) {
              let date = new Date(val);

              let hour = date.getHours();
              let minutes = date.getMinutes();
              let seconds = date.getSeconds();

              if (hour < 10) {
                hour = "0" + hour.toString();
              }

              if (minutes < 10) {
                minutes = "0" + minutes.toString();
              }

              if (seconds < 10) {
                seconds = "0" + seconds.toString();
              }

              return Strings.TIME_DP + hour + ":" + minutes + ":" + seconds;
            },
          },
        },
        chart: {
          id: "ping-graph",
          type: "line",
          locales: [chartLocale],
          defaultLocale: "application-language",
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: "reset"
          },
          animations: {
            enabled: false,
            easing: "linear",
            speed: 500,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
        },
        colors: [Constants.TEAL_HEX, Constants.ORANGE_HEX, Constants.GREY_HEX, Constants.RED_HEX, Constants.BLUE_HEX],
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth",
          width: 2
        },
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME
          },
          crosshairs: {
            show: "true"
          },
          tooltip: {
            enabled: false
          },
          labels: {
            show: true,
            formatter: function (value) {
              let date = new Date(value);

              let hour = date.getHours();
              let minutes = date.getMinutes();
              let seconds = date.getSeconds();

              if (hour < 10) {
                hour = "0" + hour.toString();
              }

              if (minutes < 10) {
                minutes = "0" + minutes.toString();
              }

              if (seconds < 10) {
                seconds = "0" + seconds.toString();
              }

              return hour + ":" + minutes + ":" + seconds;
            }
          }
        },
        yaxis: {
          min: 0,
          max: 2,
          labels: {
            formatter: function (val) {
              return val.toFixed(2) + Strings.MILLISECONDS_SUFFIX;
            },
          },
          title: {
            text: Strings.PING_MILLISECONDS
          },
        },
        annotations: {
          position: "front",
          xaxis: []
        }
      },
      previousMax: 2,
      selectedDevices: 0,
      startTime: -1
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        startTime: (data.startTime)
      }, () => {
        fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
          .then(res => res.json())
          .then(data => this.setState({
            checkboxList: this.createCheckboxList(data),
            devices: this.filterEmptyTendencyAndDuplicatedDevices(data).sort((a, b) => {
              const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
              const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
              return num1 - num2;
            }),
          }, () => {
            this.handleLiveListCellClick();
          }));
      }));
  }

  handleLiveListCellClick = () => {
    if (this.props.location.state !== undefined) {
      if (this.props.location.state.deviceIP !== undefined) {

        let checkboxList = { ...this.state.checkboxList };
        checkboxList[this.props.location.state.deviceIP] = {
          checked: !checkboxList[this.props.location.state.deviceIP].checked
        };

        this.setState({ checkboxList: checkboxList }, () => {

          for (let i = 0; i < this.state.devices.length; i++) {
            if (this.state.devices[i].ip === this.props.location.state.deviceIP) {
              let newSeries = [...this.state.series];

              newSeries.push({
                name: this.state.devices[i].ip,
                data: this.buildGraphData(this.state.devices[i].ntp, this.state.devices[i].tendency, this.state.devices[i].tendencyTime)
              });

              let oldMax = this.state.options.yaxis.max;
              let currentSeriesMax = Math.ceil(Math.max(...this.state.devices[i].tendency));

              // Se o máximo da serie for maior que o máximo antigo
              // Coloque ele como o novo máximo
              if (currentSeriesMax > oldMax) {
                this.setState({
                  selectedDevices: this.state.selectedDevices + 1,

                  previousMax: oldMax,
                  series: newSeries,
                  options: {
                    ...this.state.options, yaxis: {
                      ...this.state.options.yaxis,
                      max: currentSeriesMax
                    },
                  }
                });
              }
              else {
                this.setState({
                  selectedDevices: this.state.selectedDevices + 1,

                  series: newSeries,
                  options: {
                    ...this.state.options, yaxis: {
                      ...this.state.options.yaxis,
                      max: oldMax
                    },
                  }
                });
              }
              break;
            }
          }

        });
      }
    }
  }

  filterEmptyTendencyAndDuplicatedDevices = (devices) => {
    let newDevices = [];

    for (let i = 0; i < devices.length; i++) {
      if (devices[i].tendency !== undefined
        && devices[i].tendency !== null
        && devices[i].tendency.length > 8
        && !devices[i].isDuplicated) {

        newDevices.push(devices[i]);

      }
    }

    return newDevices;
  }

  createCheckboxList = (devices) => {
    let checkboxList = {};

    for (let i = 0; i < devices.length; i++) {
      checkboxList[devices[i].ip] = { checked: false };
    }

    return checkboxList;
  }

  getDeviceMaxPingValue = (devicePingData) => {
    let pingValues = [];

    for (let i = 0; i < devicePingData.length; i++) {
      pingValues.push(devicePingData[i][1]);
    }

    return Math.max(...pingValues);
  }

  searchForPreviousMax = (devicesPingData, deselectedIp) => {
    let maxArray = [];

    for (let i = 0; i < devicesPingData.length; i++) {
      // Only search for the max values of devices that are not the one that is being deselected
      if (devicesPingData[i].name !== deselectedIp) {
        maxArray.push(this.getDeviceMaxPingValue(devicesPingData[i].data));
      }
    }

    // Make the new max be the first integer number bigger than the max ping
    return Math.ceil(Math.max(...maxArray));
  }

  handleChange = (e, { value }) => {
    if (this.state.selectedDevices < 5 || this.state.checkboxList[value].checked) {
      // Marcar/desmarcar a checkbox selecionada
      let checkboxList = { ...this.state.checkboxList };
      checkboxList[value] = { checked: !checkboxList[value].checked };

      this.setState({ checkboxList: checkboxList }, () => {
        // Se marcou a checkbox, adicione os pings do device ao gráfico
        if (checkboxList[value].checked) {

          for (let i = 0; i < this.state.devices.length; i++) {
            if (this.state.devices[i].ip === value) {
              let newSeries = [...this.state.series];

              newSeries.push({
                name: this.state.devices[i].ip,
                data: this.buildGraphData(this.state.devices[i].ntp, this.state.devices[i].tendency, this.state.devices[i].tendencyTime)
              });

              let oldMax = this.state.options.yaxis.max;
              let currentSeriesMax = Math.ceil(Math.max(...this.state.devices[i].tendency));

              // Se o máximo da serie for maior que o máximo antigo
              // Coloque ele como o novo máximo
              if (currentSeriesMax > oldMax) {
                this.setState({
                  selectedDevices: this.state.selectedDevices + 1,

                  previousMax: oldMax,
                  series: newSeries,
                  options: {
                    ...this.state.options, yaxis: {
                      ...this.state.options.yaxis,
                      max: currentSeriesMax
                    },
                  }
                });
              }
              else {
                this.setState({
                  selectedDevices: this.state.selectedDevices + 1,

                  series: newSeries,
                  options: {
                    ...this.state.options, yaxis: {
                      ...this.state.options.yaxis,
                      max: oldMax
                    },
                  }
                });
              }
              break;
            }
          }

        }
        // Se desmarcou a checkbox, remova os pings do gráfico
        else {
          let newSeries = [...this.state.series];
          for (let i = 0; i < newSeries.length; i++) {
            if (newSeries[i].name === value) {
              newSeries.splice(i, 1); // Remove os dados

              let previousYAxisMax = this.searchForPreviousMax(newSeries, value);

              // Se só houver um dispositivo selecionado, o último máximo para
              // o eixo y não existirá, então forçamos ele a ser 2, que é 
              // valor o padrão ao entrar na tela de gráfico de ping
              if (previousYAxisMax === -Infinity) {
                previousYAxisMax = 2;
              }

              this.setState({
                selectedDevices: this.state.selectedDevices - 1,
                series: newSeries,
                options: {
                  ...this.state.options, yaxis: {
                    ...this.state.options.yaxis,
                    max: previousYAxisMax
                  },
                }
              });

              break;
            }
          }
        }
      });
    }
  }

  buildGraphData = (ntp, tendency, tendencyTime) => {
    let data = [];

    for (let i = 0; i < tendency.length; i++) {
      let pingTime = 0;

      if (ntp) {
        pingTime = Date.parse(tendencyTime[i].substring(0, tendencyTime[i].length - 4));
      }
      else {
        const eventTimeInMillis = tendencyTime[i] * 1000;
        const uptimeInMillis = this.state.startTime * 1000;
        const timeNow = new Date().getTime();
        pingTime = timeNow - uptimeInMillis + eventTimeInMillis;
      }

      data.push([pingTime, tendency[i]]);
    }

    return data;
  }

  adjustChartHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    if (browserHeight >= 950) {
      return "600px";
    }
    else if (browserHeight >= 800 && browserHeight < 950) {
      return "540px";
    }
    else if (browserHeight >= 600 && browserHeight < 800) {
      return "450px";
    }
    else {
      return "250px";
    }
  };

  adjustCheckboxGroupHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    if (browserHeight >= 950) {
      return "550px";
    }
    else if (browserHeight >= 800 && browserHeight < 950) {
      return "490px";
    }
    else if (browserHeight >= 600 && browserHeight < 800) {
      return "400px";
    }
    else {
      return "190px";
    }
  };

  handleDeselectAllButtonClick = () => {
    let checkboxList = { ...this.state.checkboxList };

    for (let i = 0; i < this.state.devices.length; i++) {
      checkboxList[this.state.devices[i].ip].checked = false;
    }

    this.setState({
      checkboxList: checkboxList,
      series: [],
      options: {
        title: {
          text: Strings.PING_GRAPH,
          align: "center",
        },
        tooltip: {
          enabled: true,
          intersect: false,
          shared: false,
          onDatasetHover: {
            highlightDataSeries: true
          },
          x: {
            show: true,
            formatter: function (val) {
              let date = new Date(val);

              let hour = date.getHours();
              let minutes = date.getMinutes();
              let seconds = date.getSeconds();

              if (hour < 10) {
                hour = "0" + hour.toString();
              }

              if (minutes < 10) {
                minutes = "0" + minutes.toString();
              }

              if (seconds < 10) {
                seconds = "0" + seconds.toString();
              }

              return Strings.TIME_DP + hour + ":" + minutes + ":" + seconds;
            },
          },
        },
        chart: {
          id: "ping-graph",
          type: "line",
          locales: [chartLocale],
          defaultLocale: "application-language",
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: "reset"
          },
          animations: {
            enabled: false,
            easing: "linear",
            speed: 500,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
        },
        colors: [Constants.TEAL_HEX, Constants.ORANGE_HEX, Constants.GREY_HEX, Constants.RED_HEX, Constants.BLUE_HEX],
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth",
          width: 2
        },
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME
          },
          crosshairs: {
            show: "true"
          },
          tooltip: {
            enabled: false
          },
          labels: {
            show: true,
            formatter: function (value) {
              let date = new Date(value);

              let hour = date.getHours();
              let minutes = date.getMinutes();
              let seconds = date.getSeconds();

              if (hour < 10) {
                hour = "0" + hour.toString();
              }

              if (minutes < 10) {
                minutes = "0" + minutes.toString();
              }

              if (seconds < 10) {
                seconds = "0" + seconds.toString();
              }

              return hour + ":" + minutes + ":" + seconds;
            }
          }
        },
        yaxis: {
          min: 0,
          max: 2,
          labels: {
            formatter: function (val) {
              return val.toFixed(2) + Strings.MILLISECONDS_SUFFIX;
            },
          },
          title: {
            text: Strings.PING_MILLISECONDS
          },
        },
        annotations: {
          position: "front",
          xaxis: []
        }
      },
      previousMax: 2,
      selectedDevices: 0
    });
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
  }

  render() {
    const devices = this.state.devices.map(device => (
      <Form.Field key={device.mac}>
        <Checkbox
          value={device.ip}
          label={device.ip}
          checked={this.state.checkboxList[device.ip].checked === true}
          onChange={this.handleChange}
        />
      </Form.Field>
    ));

    return (
      <div style={screenStyle}>

        <Grid columns={2} doubling>
          <Grid.Row>

            <Grid.Column width={4}>

              <Segment>
                <Divider horizontal style={dividerStyle}>
                  {Strings.DEVICES}
                  <Popup wide position='bottom center' hoverable
                    trigger={<Icon name="info circle" color="teal" style={{ marginLeft: "4px" }} />}>
                    <Popup.Content>
                      <p>{Strings.DEVICES_TOOLTIP_1}</p>
                      <p>{Strings.DEVICES_TOOLTIP_2}</p>
                    </Popup.Content>
                  </Popup >
                </Divider>
                <Form.Group style={{
                  maxHeight: this.adjustCheckboxGroupHeight(),
                  overflowY: "scroll",
                  marginBottom: "1vh"
                }}>
                  {devices}
                </Form.Group>

                <Button
                  content={Strings.DESSELECT_ALL}
                  color="teal"
                  fluid
                  onClick={this.handleDeselectAllButtonClick}
                />

              </Segment>

            </Grid.Column>

            <Grid.Column width={12}>
              <Segment textAlign="right">

                <Chart
                  options={this.state.options}
                  series={this.state.series}
                  type="line"
                  height={this.adjustChartHeight()} />

              </Segment>

            </Grid.Column>

          </Grid.Row>
        </Grid>

      </div>
    );
  }
}

const screenStyle = {
  marginTop: "4vh",
  marginRight: "2vw",
  marginLeft: "2vw",
  textAlign: "center",
};

const dividerStyle = {
  marginTop: "-0.2vh"
};

export default withRouter(PingGraph);
